document.addEventListener("DOMContentLoaded", () => {
    let swiper
    let swiper2
    initSwiper()

    window.addEventListener("resize", () => {
        initSwiper()
    })

    function initSwiper() {
        try {
            swiper?.destroy()
            swiper2?.destroy()
            const agendaHeader = document.querySelector('.agenda-tab__header');
            const agendaContent = document.querySelector('.agenda-tab__content');
            if (agendaHeader) {
                swiper = new Swiper(".agenda-tab__header", {
                    spaceBetween: 50,
                    slidesPerView: 2,
                    watchSlidesProgress: true,
                    breakpoints: {
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 10,
                            allowTouchMove: false,
                            slidesPerView: "auto",
                        },
                    },
                })
            }
                
            if (agendaContent) {
                swiper2 = new Swiper(".agenda-tab__content", {
                    spaceBetween: 10,
                    navigation: {
                        nextEl: '.agenda-block-arrow.agenda-block-arrow--next',
                        prevEl: '.agenda-block-arrow.agenda-block-arrow--prev'
                    },
                    thumbs: { swiper },
                })
            }
        } catch (error) {
            console.log({ error })
        }
    }
})
